import React from 'react';
import { Layers3, Sparkles, Wand2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useI18n } from '../../hooks/useI18n';

export const PublicTemplateEmptyState = ({ onCreateProject, actionLabel, compact = false }) => {
  const { t } = useI18n();

  if (compact) {
    return (
      <div className="rounded-xl border border-dashed border-border/80 px-4 py-8 text-center">
        <p className="text-sm text-muted">{t('publicTemplatesEmptyTitle')}</p>
        {onCreateProject ? (
          <Button variant="secondary" className="mt-4" onClick={onCreateProject}>
            <Wand2 size={16} />
            {actionLabel || t('publicTemplatesEmptyAction')}
          </Button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-[1.75rem] border border-dashed border-border bg-gradient-to-br from-accent-soft/50 via-white/40 to-teal-400/10 px-6 py-10 text-center dark:from-accent/10 dark:via-slate-950/20 dark:to-teal-500/5 md:px-10 md:py-12">
      <div className="pointer-events-none absolute -start-8 top-6 h-28 w-28 rounded-full bg-accent/15 blur-3xl" />
      <div className="pointer-events-none absolute -end-6 bottom-4 h-32 w-32 rounded-full bg-teal-400/15 blur-3xl" />

      <div className="relative mx-auto flex max-w-lg flex-col items-center">
        <div className="relative mb-6 flex h-24 w-full max-w-xs items-end justify-center gap-2">
          <div className="h-14 w-[30%] -rotate-6 rounded-2xl border border-border/80 bg-white/70 shadow-sm dark:bg-slate-900/50" />
          <div className="z-10 flex h-20 w-[38%] flex-col items-center justify-center gap-2 rounded-2xl border border-accent/25 bg-panel shadow-floating">
            <Sparkles size={22} className="text-accent" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-muted">
              {t('publicTemplatesEmptyBadge')}
            </span>
          </div>
          <div className="h-14 w-[30%] rotate-6 rounded-2xl border border-border/80 bg-white/70 shadow-sm dark:bg-slate-900/50" />
        </div>

        <div className="inline-flex items-center gap-2 rounded-full border border-border bg-panel/80 px-3 py-1.5 text-xs font-semibold text-muted backdrop-blur">
          <Layers3 size={14} className="text-accent" />
          {t('publicTemplatesEmptyEyebrow')}
        </div>

        <h3 className="mt-4 text-xl font-bold tracking-tight text-text">{t('publicTemplatesEmptyTitle')}</h3>
        <p className="mt-3 max-w-md text-sm leading-7 text-muted">{t('publicTemplatesEmptyBody')}</p>

        {onCreateProject ? (
          <Button className="mt-6" onClick={onCreateProject}>
            <Wand2 size={16} />
            {actionLabel || t('publicTemplatesEmptyAction')}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
